module.exports = __webpack_public_path__ + "static/media/CHOPCE_MENU-normal.438386b9.png";